import { useLocation } from 'react-router-dom';
import { ROUTES } from '../constants/constants';
import { FeatureSelectionTab } from '../interface/featureSelection';
import { useFeatureContext } from '../context/FeatureContext';

const QUICK_ACTION_EXCLUDED_ROUTES = new Set([
  ROUTES.DEFAULT,
  ROUTES.ADD_EDIT_CRITICAL_TASK,
  ROUTES.ADD_EDIT_TASK,
  ROUTES.MATTER_SELECTION,
  ROUTES.ADD_SKILLS,
  ROUTES.ADD_TRANSACTION_FROM_MAIL,
  ROUTES.FEATURE_SELECTION,
  ROUTES.TIMER_ADD_EDIT,
  ROUTES.ANALYTICS,
  ROUTES.ERROR,
  ROUTES.ACCESS_FORBIDDEN,
  ROUTES.WORK_TIME_TYPE,
  ROUTES.NEED_SUGGESTIONS,
  ROUTES.NO_INTERNET,
  ROUTES.ADD_EDIT_TRANSACTION,
  ROUTES.MATTER_REQUEST,
  ROUTES.TASK_PRIORITY_SELECTION,
  ROUTES.CONFLICT_CHECKS,
]);

const QUICK_ACTION_EXCLUDED_PATTERNS = [
  new RegExp(`^${ROUTES.ADD_EDIT_CRITICAL_TASK}(/.*)?$`),
  new RegExp(`^${ROUTES.ADD_EDIT_TASK}(/.*)?$`),
  new RegExp(`^${ROUTES.ADD_EDIT_TRANSACTION}(/.*)?$`),
  new RegExp(`^${ROUTES.ADD_EDIT_WORK_TIME}(/.*)?$`),
];

export const useQuickAction = () => {
  const location = useLocation();
  const { features } = useFeatureContext();

  const shouldShowAction = (requiredFeatures: FeatureSelectionTab[]): boolean => {
    const currentPath = location.pathname;

    if (QUICK_ACTION_EXCLUDED_ROUTES.has(currentPath)) {
      return false;
    }
    if (QUICK_ACTION_EXCLUDED_PATTERNS.some((pattern) => pattern.test(currentPath))) {
      return false;
    }
    if (requiredFeatures.length === 0) {
      return true;
    }
    return requiredFeatures.some((feature) => features[feature] === true);
  };

  return {
    shouldShowQuickAction: shouldShowAction([]),
    shouldShowTransactionMailAction: shouldShowAction([]),
  };
};
